import composite from './composite';
import smart from './smart';
import warehouse from './warehouse';
import optimize from './optimize';
import bulk from './bulk';
import park from './park';
import online from './online';

const banner = {
  title: '客户案例',
  description: '累计服务10000+国内外大中型企业',
  bg: '/imgs/case/banner.png'
};

const menu = [
  {key: 'composite', title: '综合物流案例'},
  {key: 'smart', title: '智慧运输案例'},
  {key: 'warehouse', title: '仓配案例'},
  {key: 'optimize', title: '零担运输路径优化案例'},
  {key: 'bulk', title: '大宗物流案例'},
  {key: 'park', title: '园区物流案例'},
  {key: 'online', title: '综合电商平台案例'}
];

const content = {
  composite,
  smart,
  warehouse,
  optimize,
  bulk,
  park,
  online
};

const lg = {
  online: 3
};

const md = {
  composite: 2,
  bulk: 2,
  online: 2
};

const lm = {
  online: 3
};

export {banner, menu, content, lg, md, lm};


// WEBPACK FOOTER //
// ./src/routes/Case/config/index.js